




/**
 * TODO: Documentation
 * `Tracking` - Wrapper component used to initiate our tracking service.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import initializeTracking from './TrackingUtils';

export default ComponentInitializeDispatcher.extend({
  name: 'owc-tracking',
  props: {
    datajson: {
      type: String,
      required: true,
    },
  },
  mounted() {
    initializeTracking(JSON.parse(this.datajson));
  },
});
